class TdSeoPagination extends HTMLElement {
  connectedCallback() {
    this.list = this.closest('results-list');
    if (!this.list) return;
    this.observer = new MutationObserver((records) => {
      const changed = records.some((record) => record.target.matches?.('[ref="grid"]') ||
        Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
          (node.matches('[ref="grid"]') || node.querySelector('[ref="grid"]'))));
      if (changed) this.updatePosition();
    });
    this.observer.observe(this.list, { childList: true, subtree: true });
    this.updatePosition();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  updatePosition() {
    const grid = this.list?.querySelector('[ref="grid"]');
    if (!grid) return;
    const pages = Array.from(grid.children)
      .map((card) => Number(card.dataset.page))
      .filter((page) => Number.isInteger(page) && page > 0);
    if (!pages.length) return;
    const first = Math.min(...pages);
    const last = Math.max(...pages);
    const total = Number(grid.dataset.lastPage || this.dataset.totalPages);
    if (!Number.isInteger(total) || total < 1) return;
    this.updateLink('[data-previous]', first - 1, first > 1);
    this.updateLink('[data-next]', last + 1, last < total);
    const position = this.querySelector('[data-position]');
    if (!position) return;
    const template = first === last ? position.dataset.single : position.dataset.range;
    if (!template) return;
    const label = template.replace('[page]', first).replace('[first]', first).replace('[last]', last);
    if (position.textContent.trim() !== label) position.textContent = label;
  }

  updateLink(selector, page, enabled) {
    const link = this.querySelector(selector);
    if (!link) return;
    link.hidden = !enabled;
    if (!enabled) return;
    const url = new URL(window.location.href);
    if (page === 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    url.hash = '';
    link.href = url.toString();
  }
}

if (!customElements.get('td-seo-pagination')) {
  customElements.define('td-seo-pagination', TdSeoPagination);
}
